import { render, staticRenderFns } from "./linkDialog.vue?vue&type=template&id=108d5966&scoped=true&"
import script from "./linkDialog.vue?vue&type=script&lang=js&"
export * from "./linkDialog.vue?vue&type=script&lang=js&"
import style0 from "./linkDialog.vue?vue&type=style&index=0&id=108d5966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108d5966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('108d5966')) {
      api.createRecord('108d5966', component.options)
    } else {
      api.reload('108d5966', component.options)
    }
    module.hot.accept("./linkDialog.vue?vue&type=template&id=108d5966&scoped=true&", function () {
      api.rerender('108d5966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/user/components/linkDialog.vue"
export default component.exports